// extracted by mini-css-extract-plugin
module.exports = {"rainbow-border":"FinishOnPhone_rainbow-border__TKyIo"};